import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {initTheme} from './app/utility/theme';

// Reconciles the data-theme attribute the inline script in public/index.html
// already set, then keeps following the OS for as long as the user has not
// pinned a mode. Runs before render so the first paint is already correct.
initTheme ();

const root = ReactDOM.createRoot (document.getElementById ('root'));
root.render (
  // <React.StrictMode>
  <App />
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals ();
